export default {
  // form validation rules
  required: (v) => !!v || "Required.",
  name: (v) => (v && v.length >= 2) || "Invalid name.",
  phone: (v) =>
    (v && /\d{10}/.test(v) && v.length === 10) || "Invalid phone number.",

  email: (v) => /.+@.+\..+/.test(v) || "Invalid e-mail.",
  password: {
    min: (v) => v.length >= 8 || "Min 8 characters.",
  },
  multiple: (v) => v.length > 0 || "Required.",
  money: (v) =>
    /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/.test(v) ||
    "Invalid money format eg. 10.04 or 5",
  tin: (v) => (v && v.length === 11) || "Invalid TIN.",
};
